module.exports = __webpack_public_path__ + "static/img/Joe-Ofahengaue.ea2445f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Joe-Ofahengaue.jpg
// module id = AlsH
// module chunks = 0